import styled from 'styled-components';

export const SelectorContainer = styled.div`
    width: fit-content;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const ScenarioList = styled.div`
    margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const ScenarioItem = styled.div<{ $isLast: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacing(1)} 0`};
    border-bottom: ${({ theme, $isLast }) => ($isLast ? 'none' : `1px solid ${theme.tokens.BaseColorGray300}`)};
`;

export const ScenarioLeft = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
`;

export const VehicleLabel = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    white-space: nowrap;
`;

export const PaymentDetails = styled.span`
    white-space: nowrap;
    margin-left: ${({ theme }) => theme.spacing(6)};
`;
